const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.superadmin_product_subgroups/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.superadmin_product_subgroups/LIST_PRODUCT_SUBGROUPS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
